module.exports = __webpack_public_path__ + "static/media/gk-baies-solo.3bb19266.png";